import React, { Component } from "react";

const prepaidList = [
  {
    id: 1,
    title: "05 DIAMOND MEMBER",
    balance: 926.82,
  },
  {
    id: 2,
    title: "PRODUCT PACKAGE (MEDITRINACRM)",
    balance: 658.38,
  },
  {
    id: 3,
    title: "RODUCT PACKAGE (MEDITRINACRM) (FOC)",
    balance: 316.0,
  },
  {
    id: 4,
    title: "PRODUCT PACKAGE (MEDITRINACRM)",
    balance: 1580.0,
  },
];

export default class PrepaidDesc extends Component {
  render() {
    let { showprepaid, prepaidlst } = this.props.footer;
    return (
      <div className="row pt-3">
        {showprepaid && prepaidlst && prepaidlst.length > 0 && (
          <div className="col-md-7">
            <div className="d-flex prepaidDesContainer border1px">
              <div className="width80 ">
                <p className="text-center text-dark fw-600 ">Program Desc </p>
              </div>
              <div className="width20 borderLeft1px">
                <p className="text-center  text-dark fw-600"> Balance</p>
              </div>
            </div>
            <div className="borderTopHide">
              {prepaidlst.map((list, id) => {
                return (
                  <div key={id} className="d-flex prepaidDesContainer ">
                    <div className="width80 ">
                      <p className="text-center text-dark fs-12 ">
                        {list.pp_desc}
                      </p>
                    </div>
                    <div className="width20 ">
                      <p className="text-center text-dark fs-12">
                        {" "}
                        {list.remain}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}
